import React from 'react';
import SectionComponent from "./SectionComponent";
import { IMG_COMMERCIAL } from "../../data/constructionServiceImages";

function CommercialFitOut() {
  return (
    <SectionComponent
      images={IMG_COMMERCIAL}
      titles={{
        mainTitle: "Commercial construction & fit-out",
        subTitle: "Delivery for occupied and phased environments",
        sectionTitle1: "Base build coordination",
        sectionTitle2: "MEP & specialist interfaces",
        sectionTitle3: "Completion & handover",
        sectionTitle4: "Project photography",
      }}
      descriptions={{
        sectionDescription1: "We coordinate shell, core, and tenant packages where multiple stakeholders share deadlines—keeping access, noise, and safety constraints visible in the plan.",
        sectionDescription2: "We align ceiling, services, and FF&E routes with consultant drawings, resolving clashes early so site time protects design intent.",
        sectionDescription3: "Handover includes O&M structure, training where required, and snagging closure with a clear sign-off path for the professional team.",
        imageAlt: "Commercial interior construction"
      }}
      galleryLink="/projects/commercial"
      seo={{
        title: "Commercial construction & fit-out",
        description: "Commercial construction and fit-out with consultant coordination and phased delivery. MA Renovations."
      }}
    />
  )
}

export default CommercialFitOut;
